const PSEvents = require('PSEvents');

const SlotUI = require('SlotUI');
const i18n = require('i18n');

cc.Class({
    extends: cc.Component,

    properties: {
        featureId: '[Feature ID is mandatory]',
        priceLabel: cc.Label,
        buyButton: cc.Button,
    },

    ctor() {
        if (SlotUI.isReplayMode()) {
            this.locked = true;
        } else {
            this.locked = false;
        }
    },

    init(purhcaseData) {
        this.feature = purhcaseData.feature;
        this.price = purhcaseData.price;
        this.availableBetsAmounts = purhcaseData.availableBetsAmounts;
    },

    updateBet (betAmount, balance) {
        const cost = this.price * betAmount;
        this.betAmount = betAmount;
        this.balance = balance;
        this.priceLabel.string = i18n.formatCurrency(cost);
        this._updateButtonState();
    },

    _updateButtonState () {
        const cost = this.price * this.betAmount;
        const isValidBetAmount = this.availableBetsAmounts.includes(this.betAmount);
        this.buyButton.interactable = isValidBetAmount && cost <= this.balance && !this.locked;
    },

    lockButton () {
        this.locked = true;
        if (this.initialized) {
            this._updateButtonState();
        }
    },

    unlockButton () {
        this.locked = false;
        if (this.initialized) {
            this._updateButtonState();
        }
    },

    buyClicked () {
        PSEvents.publish(PSEvents.BUY_REQUEST, { featureId: this.feature, selectedBet: this.betAmount });
    },
});
